'use client'

import type { LogsEvent } from '@datadog/browser-logs'

interface ImageErrorEvent extends Omit<LogsEvent, 'message'> {
  error?: {
    origin?: string
    message?: string
    stack?: string
  }
  status?: string
  message: string
}

export const datadogBeforeSend = (event: ImageErrorEvent): boolean => {
  const isImageLoadFailure =
    event.origin === 'console' &&
    event.message.includes('upstream image response failed for')

  if (!isImageLoadFailure) return true

  const parts = event.message.split(',')
  const imageUrl = parts[parts.length - 1]?.trim()

  const enrichedErrorContext = {
    imageUrl: imageUrl || 'unknown',
    pageUrl: typeof window !== 'undefined' ? window.location.href : 'unknown',
    pathname:
      typeof window !== 'undefined' ? window.location.pathname : 'unknown',
    timestamp: new Date().toISOString(),
    userAgent: typeof window !== 'undefined' ? navigator.userAgent : 'unknown',
    errorType: 'IMAGE_LOAD_FAILURE',
  }

  const updatedEvent: ImageErrorEvent = {
    ...event,
    status: 'info',
    message: `Image load failed: ${enrichedErrorContext.imageUrl}`,
    error: {
      ...event.error,
      stack: JSON.stringify(enrichedErrorContext),
    },
  }

  Object.assign(event, updatedEvent)

  return true
}
